require('./rosterService');
require('../../shared/singleGameService');

"use strict";

angular.module('app.player.rosterController', [
  'app.player.rosterService',
  'app.shared.singleGameService'
])
  .controller('app.player.rosterController', [
    '$scope',
    'app.player.rosterService',
    'app.shared.singleGameService',
    function ($scope, roster, singleGame) {
      $scope.roster = roster;

      let init = function () {
        if (singleGame.data) {
          roster.retrieve(singleGame.data.igameid);
        }
      };

      $scope.positionGroups = [{
        name: 'Forwards',
        positions: ['LW', 'RW', 'F', 'C']
      }, {
        name: 'Defensemen',
        positions: ['RD', 'LD', 'D']
      }, {
        name: 'Goalies',
        positions: ['G']
      }];

      $scope.statColumns = ['G','A','PTS','PIM','+/-','SHOTS'];

      $scope.showProfile = (player) => {
        $scope.currentProfile = player;
        $scope.currentSeasonYear = roster.current_season_year;
        $scope.client_code = roster.client_code;
      };

      $scope.hideProfile = () => {
        $scope.currentProfile = null;
      };

      $scope.$watch(
        () => {
          return singleGame.data;
        },
        () => {
          init();
        }
      );

      init();
    }
  ])
  .filter('positionGroupFilter', function () {
    return function (players, positions) {
      return _.filter(players, function (player) {
        return _.includes(positions, player.strplayerposition);
      })
    }
  });


// WEBPACK FOOTER //
// ./app.v2/components/player/roster/rosterController.js